import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.$title = this.$('label');
        this.splitTitle();
    }


    splitTitle() {
        this.$title.forEach(item => {
            let currentTitle = item.innerHTML;

            if(!currentTitle.includes('+')) {
                return;
            }

            let changeCharacter = currentTitle.replace('+', '</span></span><span><span>+</span></span><span><span>')
            let newTitle = `<span><span>${changeCharacter}</span></span>`

            item.innerHTML = newTitle
        })
    }
}
